// /**
//  * Users - Add
//  */

// React
import React, {useRef, useState} from 'react';

// react hook form
import {useForm} from 'react-hook-form';

// UI
import {makeStyles, Theme, createStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import {
  TextField,
  Grid,
  Button,
  InputLabel,
  Select,
  FormControl,
  IconButton,
  InputAdornment,
  Input,
  FormHelperText,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiEmailOutline,
  mdiPhoneOutline,
  mdiCardAccountDetailsOutline,
  mdiKeyOutline,
  mdiEyeOutline,
  mdiEyeOffOutline,
} from '@mdi/js';

// helpers
import {flattenObject, removeEmptyValueObject} from '../../../utils/helpers';

// Type
import {User} from '../../users/interfaces';

type Props = {
  createUser: (body: User, callback: () => void) => void;
  error: any;
  onClose: () => void;
};

type Inputs = {
  name: String;
  username: String;
  phoneNumber: String;
  emailAddress: String;
  password: string;
  password_repeat: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    margin: {
      // margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      // width: '25ch',
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      // marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '8px',
      marginTop: '21px',
    },
  })
);

export default function Add(props: Props) {
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const {register, handleSubmit, watch, errors, reset, getValues} =
    useForm<Inputs>();
  const password = useRef({});
  password.current = watch('password', '');
  const onSubmit = (data: any) => {
    const {name, password, phoneNumber, emailAddress} = data;
    props.createUser(
      {
        name: name.trim(),
        password: password.length > 0 ? password : null,
        phoneNumber,
        emailAddress,
        status: 'REGISTERED',
        role: 'NONE',
      },

      () =>
        reset({
          ...getValues(),
          name: '',
          emailAddress: '',
          password: '',
          password_repeat: '',
          phoneNumber: '',
        })
    );
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={4} alignItems="flex-start">
        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiAccountOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{width: '100%'}}>
              <TextField
                fullWidth
                id="name"
                name="name"
                label="نام"
                inputRef={register({required: true})}
                error={errors.name && true}
              />
            </div>
          </div>
        </Grid>

        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiPhoneOutline}
                size={1}
                className={classes.icon}
                style={{transform: 'rotate(-90deg)'}}
              />
            </span>

            <span style={{width: '100%'}}>
              <TextField
                fullWidth
                id="phoneNumber"
                name="phoneNumber"
                label="شماره موبایل"
                inputRef={register({required: true})}
                error={
                  (errors.phoneNumber ||
                    props.error?.errorKey === 'phoneNumber.duplicate') &&
                  true
                }
                helperText={
                  errors.phoneNumber
                    ? 'شماره موبایل وارده نشده است'
                    : props.error?.errorKey === 'phoneNumber.duplicate' &&
                      'شماره موبایل وارده شده تکراری است'
                }
              />
            </span>
          </div>
        </Grid>

        <Grid container item xs={6} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiEmailOutline} size={1} className={classes.icon} />
            </span>
            <span style={{width: '100%'}}>
              <TextField
                fullWidth
                id="emailAddress"
                name="emailAddress"
                label="ایمیل"
                error={
                  (errors.emailAddress ||
                    props.error?.errorKey === 'emailAddress.duplicate') &&
                  true
                }
                helperText={
                  errors.emailAddress
                    ? 'ایمیل وارد نشده است'
                    : props.error?.errorKey === 'emailAddress.duplicate' &&
                      'ایمیل وارد شده تکراری است'
                }
                inputRef={register({
                  required: true,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'فرمت ایمیل اشتباه است',
                  },
                })}
              />
            </span>
          </div>
        </Grid>

        <Grid container item xs={6} alignItems="flex-start">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiKeyOutline} size={1} className={classes.icon} />
            </span>

            <span>
              <FormControl
                fullWidth
                className={clsx(classes.margin, classes.textField)}
                error={errors.password && true}
              >
                <InputLabel htmlFor="password">رمز عبور</InputLabel>
                <Input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  error={errors.password_repeat && true}
                  inputRef={register({
                    minLength: {
                      value: 8,
                      message: 'رمز عبور نباید کمتر از ۸ کاراکتر باشد',
                    },
                  })}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? (
                          <Icon path={mdiEyeOutline} size={1} />
                        ) : (
                          <Icon path={mdiEyeOffOutline} size={1} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                <FormHelperText>
                  <>{errors.password && errors.password.message}</>
                </FormHelperText>
              </FormControl>
            </span>
          </div>
        </Grid>

        <Grid container item xs={6} alignItems="flex-start">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiKeyOutline} size={1} className={classes.icon} />
            </span>

            <span>
              <FormControl
                fullWidth
                className={clsx(classes.margin, classes.textField)}
                error={errors.password_repeat && true}
              >
                <InputLabel htmlFor="password_repea">تکرار رمز</InputLabel>
                <Input
                  type={showPassword ? 'text' : 'password'}
                  id="password_repeat"
                  name="password_repeat"
                  error={errors.password_repeat && true}
                  inputRef={register({
                    validate: value =>
                      value === password.current || 'تکرار رمز عبور اشتباه است',
                  })}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? (
                          <Icon path={mdiEyeOutline} size={1} />
                        ) : (
                          <Icon path={mdiEyeOffOutline} size={1} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                <FormHelperText>
                  <>
                    {errors.password_repeat && errors.password_repeat.message}
                  </>
                </FormHelperText>
              </FormControl>
            </span>
          </div>
        </Grid>

        <Grid item container xs={8}>
          <Button
            fullWidth
            type="submit"
            size="large"
            data-cy="search"
            autoFocus
            variant="contained"
            color="secondary"
            disabled={
              Object.keys(flattenObject(removeEmptyValueObject({...watch()})))
                .length === 0
            }
          >
            {`ایجاد کاربر جدید`}
          </Button>
        </Grid>
        <Grid item container xs={4}>
          <Button
            fullWidth
            variant="contained"
            onClick={props.onClose}
            size="large"
            data-cy="search"
          >
            {`انصراف`}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
